module.exports = __webpack_public_path__ + "img/hk_room3.f9d7dc39.jpg";